<template>
    <div>
        <!--<div class="page-title">
            <h1 class="float-left">Select Products</h1>
            <div class="title-right float-right">

            </div>
        </div>-->
        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="col-lg-auto"><h4 class="card-title mb-0">Select Products</h4></div>
                    <div class="col-auto ms-sm-auto">
                        <a href="#" class="btn custom-btn">Create Product</a>
                    </div>
                </div>

            </div><!-- end card header -->
            <div class="card-body form-steps">
                <div class="select-step product-select-step">
                    <!-- progressbar -->
                    <div class="step-arrow-nav mb-4">
                        <ul id="progressbar" class="nav nav-pills custom-nav nav-justified">
                            <li class="active">Step 1</li>
                            <li>Step 2</li>
                            <li>Step 3</li>
                        </ul>
                    </div>

                    <!-- fieldsets -->
                    <fieldset class="search">
                        <div class="row">
                            <div class="col-sm-6 col-md-6">
                                <form class="form-inline" action="">
                                    <div class="search-box">
                                    <button class="btn btn-outline-secondary custom-btn" type="button" @click.prevent="search">
                                        <i class="ri-search-line search-icon"></i></button>
                                    <input v-model="search_filter" type="text" class="form-control search" placeholder="Quick Search">

                                    </div>
                                </form>
                            </div>
                        </div>
                    </fieldset>
                    <ValidationObserver v-slot="{ handleSubmit }" ref="formValidation">
                        <form @submit.prevent="handleSubmit(submitHandler)" enctype="multipart/form-data">
                            <div class="product-create product-height">
                                <OrderProducts
                                    :orderId="newOrder.order_id" :selectedProducts="newOrder.selectedProducts"
                                    :search_filter="search_filter"
                                    :quantityUnits="quantityUnits"
                                    @selectProduct="selectProduct($event)"
                                    @watchChangedProducts="watchChangedProducts($event)" :bus="bus" ref="productsList"
                                ></OrderProducts>

                            </div>

                            <div class="btnrow text-right">
                                <button type="submit" class="btn  btn-success right btn-label ml-3"
                                        :disabled="newOrder.products.length == 0">Next <i  class="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                                </button>
                            </div>
                        </form>
                    </ValidationObserver>


                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import Vue from "vue";
import {ValidationProvider, ValidationObserver, extend, configure} from 'vee-validate';

configure({
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid',
        dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
        // ...
    }
});

extend('positive', value => {
    if (value >= 0) {
        return true;
    }

    return 'This field must be a positive number';
});

import OrderProducts from "../../components/OrderProducts";

export default {
    name: "PurchaseSelectProducts",
    components: {
        OrderProducts,
        ValidationObserver, ValidationProvider
    },
    created() {
        this.getQuantityUnits();

        if (this.purchaseOrderState) {
            this.newOrder = _.cloneDeep(this.purchaseOrderState.newOrder);
        }
    },
    beforeRouteLeave (to, from , next) {
        if(to.name == 'purchaseSelectVendor') {
            next();
        } else {
            const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
            if (answer) {
                next();
            } else {
                next(false);
            }
        }
    },
    data() {
        return {
            bus: new Vue(),
            newOrder: {
                vendor: null,
                order_id: null,
                vendor_id: null,
                vendor_company_name: null,
                is_draft: 0,
                po_number: null,
                order_date: null,
                vendor_terms: null,
                vendor_po: null,
                vendor_fob: null,
                eta: null,
                delivery_date: null,
                notes: null,
                vendor_notes: null,
                po_status_id: 1,
                products: [],
                selectedProducts: [],
                quote_num: null
            },
            search_filter: null,
            quantityUnits: [],
            salesOrder: null
        }
    },
    mounted() {
        this.getSalesOrder();
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setNewPurchaseOrder',
            'setLoading'
        ]),
        submitHandler() {
            this.$refs.formValidation.validate().then(success => {
                if (!success) {
                    return;
                }
                if(this.newOrder.vendor_id == null) {
                    let products = this.salesOrder.products
                        .filter((x) => x.purchase_order_products &&
                            x.purchase_order_products.length && this.newOrder.selectedProducts.includes(x.id));
                    if(products.length && products[0].purchase_order_products.length && products[0].purchase_order_products[0].purchase_order &&
                        products[0].purchase_order_products[0].purchase_order.vendor_id ) {
                        this.newOrder.vendor_id = products[0].purchase_order_products[0].purchase_order.vendor_id;
                        this.newOrder.vendor_company_name = products[0].purchase_order_products[0].purchase_order.vendor.company_name;
                        this.newOrder.vendor = products[0].purchase_order_products[0].purchase_order.vendor;
                        this.newOrder.vendor_terms = products[0].purchase_order_products[0].purchase_order.vendor.vendor_terms;
                    }
                }
                this.$router.push({name: 'purchaseSelectVendor'});
            });
        },
        selectProduct(event) {
            if (event.c) {
                if (this.newOrder.selectedProducts.includes(event.c.id)) {
                    if (event.checked == false) {
                        this.newOrder.selectedProducts.splice(this.newOrder.selectedProducts.indexOf(event.c.id), 1);
                    }
                } else {
                    this.newOrder.selectedProducts.push(event.c.id);
                }

                if (this.newOrder.products.includes(event.c)) {
                    if (event.checked == false) {
                        this.newOrder.products = this.newOrder.products.filter((x) => x.order_product_id == event.c.id);
                    }
                } else {
                    let product = _.cloneDeep(event.c);
                    product.order_product_id = event.c.id;
                    product.id = null;
                    this.newOrder.products.push(product);
                }
            }
            this.newOrder.products = this.newOrder.products.filter((x) => this.newOrder.selectedProducts.includes(x.order_product_id));

            this.setNewPurchaseOrder(this.newOrder);
        },
        search() {
            this.bus.$emit('getProducts')
        },
        updateProduct(product) {
            console.log(product)
        },
        watchChangedProducts(products) {
            products.forEach((x) => {
                let prodIndex = this.newOrder.products.findIndex((y) => y.order_product_id == x.id);
                if (prodIndex > -1) {
                    this.newOrder.products[prodIndex].product_num = x.product_num;
                    this.newOrder.products[prodIndex].product_desc = x.product_desc;
                    this.newOrder.products[prodIndex].product_name = x.product_name;
                    this.newOrder.products[prodIndex].quantity = x.quantity;
                    this.newOrder.products[prodIndex].price = x.price;
                    this.newOrder.products[prodIndex].unit_price = x.price;
                    this.newOrder.products[prodIndex].uom = x.uom;
                    this.newOrder.products[prodIndex].cost = x.cost;
                }
            });

            this.setNewPurchaseOrder(this.newOrder);
        },
        getQuantityUnits() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('so-quantity-units.index'), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.quantityUnits = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getSalesOrder() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('orders.show', {id: this.newOrder.order_id}), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.salesOrder = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
    },
    watch: {
        search_filter: {
            handler: function (value) {
                if (value != null && value.length > 1) {
                    this.search();
                }
            }
        }
    },
    computed: {
        ...mapState([
            'userState',
            'purchaseOrderState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'purchaseOrdersLoading',
            'getPurchaseOrderState'
        ])
    }
}
</script>

<style scoped>

</style>
